// Static reference data - used as fallback when API returns 404
export const DEPARTMENTS = [
  { id: 1, name: 'IB PID Dept', volume_source: 'pid', volume_multiplier: 1 },
  { id: 2, name: 'Sorter Fluid Dept', volume_source: 'pid', volume_multiplier: 0.75 },
  { id: 3, name: 'EOL Dept', volume_source: 'pid', volume_multiplier: 0.25 },
  { id: 4, name: 'AROS Dept', volume_source: 'aros', volume_multiplier: 1 },
  { id: 5, name: 'Offline Fluid Dept', volume_source: 'pid_25_plus_aros', volume_multiplier: 1 },
  { id: 6, name: 'IB PR Dept', volume_source: 'pallet', volume_multiplier: 1 },
  { id: 7, name: 'PIT Dept', volume_source: 'pallet', volume_multiplier: 1 },
];

export const DEPARTMENT_GROUPS = [
  { id: 1, name: 'Inbound', departments: [1, 2, 3, 4, 5, 6, 7] },
  { id: 2, name: 'DA', departments: [] },
];

export const VOLUME_PROCESS_PATHS = [
  { id: 1, name: 'PID', key: 'pid' },
  { id: 2, name: 'AROS', key: 'aros' },
  { id: 3, name: 'Pallet Receive', key: 'pallet' },
];

export const PROCESS_PATHS = [
  { id: 1, name: 'PID Unloader', department_id: 1, baseline_cplh: 236.0 },
  { id: 2, name: 'PID Merge', department_id: 1, baseline_cplh: 480.0 },
  { id: 3, name: 'PID Reinject', department_id: 1, baseline_cplh: 4688 },
  { id: 4, name: 'PID Operator', department_id: 1, baseline_cplh: 153.1 },
  { id: 5, name: 'Direct Wallbuild', department_id: 2, baseline_cplh: 78.0 },
  { id: 6, name: 'Jam Clear', department_id: 2, baseline_cplh: 459.6 },
  { id: 10, name: 'OB TDR', department_id: 2, baseline_cplh: 957.2 },
  { id: 13, name: 'EOL Avery', department_id: 3, baseline_cplh: 237.0 },
  { id: 14, name: 'EOL Divert', department_id: 3, baseline_cplh: 481.1 },
  { id: 15, name: 'EOL Sort', department_id: 3, baseline_cplh: 121.9 },
  { id: 16, name: 'EOL Waterspider', department_id: 3, baseline_cplh: 157.7 },
  { id: 17, name: 'EOL Reinject', department_id: 3, baseline_cplh: 432.1 },
  { id: 18, name: 'AROS Unloader', department_id: 4, baseline_cplh: 350.6 },
  { id: 19, name: 'AROS Operator', department_id: 4, baseline_cplh: 721.5 },
  { id: 20, name: 'AROS Sticker', department_id: 4, baseline_cplh: 361.6 },
  { id: 21, name: 'AROS Avery', department_id: 4, baseline_cplh: 302.3 },
  { id: 22, name: 'AROS Divert', department_id: 4, baseline_cplh: 332.3 },
  { id: 23, name: 'AROS Sort', department_id: 4, baseline_cplh: 147.7 },
  { id: 24, name: 'AROS WS', department_id: 4, baseline_cplh: 227.7 },
  { id: 25, name: 'Offline WallBuild', department_id: 5, baseline_cplh: 66.1 },
  { id: 8, name: 'Fluid WS', department_id: 5, baseline_cplh: 126.4 },
  { id: 26, name: 'Fluid Offline', department_id: 5, baseline_cplh: 33.8 },
  { id: 27, name: 'PR Unload', department_id: 6, baseline_cplh: 171.0 },
  { id: 28, name: 'Pallet Build', department_id: 6, baseline_cplh: 106.8 },
  { id: 29, name: 'Wrap/Lantech', department_id: 6, baseline_cplh: 200.4 },
  { id: 30, name: 'Pallet Receiver', department_id: 6, baseline_cplh: 260.2 },
  { id: 31, name: 'Pallet Auditor', department_id: 6, baseline_cplh: 0 },
  { id: 32, name: 'IB MPJ WS', department_id: 6, baseline_cplh: 284.7 },
  { id: 33, name: 'IB EPJ', department_id: 6, baseline_cplh: 2220 },
  { id: 34, name: 'IB PIT Unload', department_id: 7, baseline_cplh: 16493 },
  { id: 35, name: 'IB PIT MPJ WS', department_id: 7, baseline_cplh: 1130 },
  { id: 36, name: 'IB PIT Build', department_id: 7, baseline_cplh: 1227 },
  { id: 37, name: 'PIT Operator', department_id: 7, baseline_cplh: 284.9 },
  { id: 38, name: 'PIT Waterspider', department_id: 7, baseline_cplh: 221.3 },
];

export const SITES = [
  { id: 'OLM1', name: 'OLM1' },
  { id: 'SIX7', name: 'SIX7' },
  { id: 'SBD3', name: 'SBD3' },
  { id: 'SCK8', name: 'SCK8' },
];

// Fetch with fallback - returns fallback data if API returns non-array
export async function fetchWithFallback(url, fallback) {
  try {
    const res = await fetch(url);
    if (!res.ok) return fallback;
    const data = await res.json();
    return Array.isArray(data) ? data : fallback;
  } catch { return fallback; }
}

// Get today's date in local timezone (avoids UTC rollover after 5pm PT)
export function localToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
